import { type AccountData, type AccountListSearch, type AccountListSuccess, HOUR, Logger } from '@terros/common'
import { keepPreviousData } from '@tanstack/react-query'
import { useTantalimQuery } from '../query'
import { accountsKey } from '../keys'
import { type GetHookResponse } from '../hooks'
import { useDecoratedAccountListInput } from './util'

const logger = new Logger('useAccounts')
// logger.level = 'verbose'

export function useAccounts(
  _input: AccountListSearch = {},
  enabled: boolean = true,
  options: { keepPreviousData?: boolean } = {}
): GetHookResponse<AccountData[]> {
  const input = useDecoratedAccountListInput(_input)

  return useTantalimQuery<AccountListSearch, AccountListSuccess, AccountData[]>({
    url: '/account/list',
    queryKey: accountsKey(input),
    input,
    convertResponse: (data) => data.accounts,
    options: {
      retry: false,
      gcTime: HOUR,
      staleTime: HOUR,
      enabled,
      placeholderData: options.keepPreviousData ? keepPreviousData : undefined,
    },
  })
}
